var map = {
	"./nervous.png": 5901,
	"./projects/bdo-shipwright.png": 2597,
	"./projects/cron-game-backup.png": 3380,
	"./projects/git-repo-manager.png": 3661,
	"./projects/git-repo-orchestrator.png": 7498,
	"./projects/landing-page.png": 5149,
	"./projects/multi-language-library.png": 4214,
	"./projects/node-backend.png": 3053,
	"./projects/task-tracker.png": 4126,
	"./projects/winget-upgrade-helper.png": 3378
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1621;